<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <el-date-picker
          v-model="timeValue"
          type="datetimerange"
          size="small"
          unlink-panels
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <input-select :selectTitle="'预约状态'" style="margin-left: 10px;" :selectData="orderCanceledList" @search="search" :selectKey="'orderCanceled'" />
      </div>
      <input-search placeholder="场地名称" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @cancelReservation="cancelReservation" :operationArr="operationArr" @seeExample="seeExample"/>

    <el-dialog
    title="场地设施"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose">
    <div class="equipment-item" style="color:#000;font-size:16px;padding-bottom:10px">
      <div>设施名称</div>
      <div>设施数量</div>
    </div>
    <div v-for="item in equipmentList" :key="item.equipmentCode" class="equipment-item">
      <div>{{item.equipmentName}}</div>
      <div>{{item.equipmentCount}}</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/SiteReservation";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "bespoke-record",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧预约",
          name: "site-management"
        },
        {
          value: "预约记录"
        }
      ],
      addCustom: "site-add",
      exportUrl: "",
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      orderCanceledList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: 0,
          label: "正常"
        },
        {
          key: 1,
          label: "已取消"
        }
      ],
      tableHead: [
        {
          prop: "personName",
          label: "预约人姓名"
        },
        {
          prop: "enterpriseName",
          label: "所属住户"
        },
        {
          prop: "personPhone",
          label: "预约人手机"
        },
        {
          prop: "placeName",
          label: "场地名称"
        },
        {
          prop: "money",
          label: "金额(元)"
        },
        {
          prop: "orderCanceledText",
          label: "预约状态"
        },
        {
          prop: "orderCanceledText",
          label: "场地设施",
          example: true
        },
        {
          prop: "memo",
          label: "备注"
        },
        {
          prop: "appointmentTime",
          width: "420",
          label: "预约时间"
        }
      ],
      tableData: [],
      equipmentList: [],
      dialogVisible: false,
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      timeValue: [],
      requestData: {
        startTime: "",
        endTime: "",
        searchKey: "",
        orderCanceled: ""
      },
      operationArr: ["cancelReservation"]
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getCreatTime();
  },
  activated() {
    this.getCreatTime();
  },
  methods: {
    getCreatTime() {
      this.timeValue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timeValue[0] = `${year}-${month}-${date} 00:00:00`;
      this.timeValue[1] = `${year}-${month}-${date} 23:59:59`;
      this.getPage();
    },
    beforeDownload() {
      this.exportUrl = `${api.exportCustom}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&orderCanceled=${this.requestData.orderCanceled}`;
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;

      if (this.timeValue) {
        this.requestData.startTime = this.timeValue[0];
        this.requestData.endTime = this.timeValue[1];
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }

      this.$axios
        .post(api.getPlaceBookingPage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              v.appointmentTime = `${v.bookingStartTime}至${v.bookingEndTime}`;
              if (v.orderCanceled === 0) {
                v.orderCanceledText = "正常";
              } else if (v.orderCanceled === 1) {
                v.orderCanceledText = "已取消";
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取记录失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    cancelReservation(data) {
      this.$confirm("是否确认取消此预约？", "温馨提示", {
        type: "warning"
      })
        .then(() => {
          let code = data.code;
          this.$axios
            .get(`${api.bookingCancel}/${code}`, {})
            .then(res => {
              nSuccess("操作成功");
              this.getPage();
            })
            .catch(errorHandler("操作失败"));
        })
        .catch(() => {
          console.log("取消操作");
        });
    },
    seeExample(row) {
      this.$axios
        .get(api.getPlaceBookingByCode + "/" + row.code, {})
        .then(res => {
          this.equipmentList = res.data.data.equipmentList;
          this.dialogVisible = true;
        });
    },
    handleClose() {
      this.dialogVisible = false;
    }
  },

  watch: {
    timeValue() {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
.equipment-item {
  display: flex;
  justify-content: space-between;
  padding: 0 50px;
}
</style>



// WEBPACK FOOTER //
// src/view/SiteReservation/BespokeRecord/BespokeRecord.vue